/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpRequestConfig } from '../core/HttpClient';
import { HttpClientDecorator } from '../core/HttpClientDecorator';

const PLATFORM_HEADER_VALUE = 'web';

export class WithPlatform extends HttpClientDecorator {
  get<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.get<ResponseData, ResponseMeta>(url, this.addPlatformHeaderToConfig(config));
  }

  post<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.post<ResponseData, ResponseMeta>(url, this.addPlatformHeaderToConfig(config));
  }

  put<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.put<ResponseData, ResponseMeta>(url, this.addPlatformHeaderToConfig(config));
  }

  private addPlatformHeaderToConfig(config: HttpRequestConfig = {}): HttpRequestConfig {
    return {
      ...config,
      headers: {
        ...config.headers,
        Platform: PLATFORM_HEADER_VALUE,
      },
    };
  }
}
